import React from "react";
import Modal from "react-bootstrap/Modal";

const ModalBox = ({ show, hide, title, children, size = "md" }) => {
  return (
    <Modal
      size={size}
      show={show}
      onHide={hide}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-dark">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default ModalBox;
